import { CdrGrid as l } from "@rei/cedar";
import { resolveComponent as a, openBlock as u, createBlock as p, normalizeClass as n, withCtx as i, createElementVNode as c, renderSlot as d } from "vue";
const m = (o, t) => {
  const e = o.__vccOpts || o;
  for (const [r, s] of t)
    e[r] = s;
  return e;
}, f = {
  name: "StoryGroup",
  components: {
    CdrGrid: l
  },
  props: {
    stacked: {
      type: Boolean,
      default: !1
    },
    invertColumnOrderOnXs: {
      type: Boolean,
      default: !1
    }
  }
}, y = {
  class: "story-group__column story-group__column--centered"
};
function g(o, t, e, r, s, v) {
  const _ = a("cdr-grid");
  return u(), p(_, {
    class: n([{
      "story-group__grid--stacked": e.stacked
    }, "story-group__grid"])
  }, {
    default: i(() => [c("div", {
      class: n(["story-group__column", {
        "story-group__column--show-last-on-xs": e.invertColumnOrderOnXs
      }])
    }, [d(o.$slots, "column-1", {}, void 0, !0)], 2), c("div", y, [d(o.$slots, "column-2", {}, void 0, !0)])]),
    _: 3
  }, 8, ["class"]);
}
const O = /* @__PURE__ */ m(f, [["render", g], ["__scopeId", "data-v-d5797d4f"]]);
export {
  O as default
};
